// TODO: inlineTextStyle should have its own suggestion type with strongly typed variants;
// it should not use `item`.
// These helpers will be largely unnecessary once that is done, and can be removed.

import type { SingleSuggestion, Suggestion } from "@/components/suggestions/types";

export const ADD_LINK_KEY = "addLink";
export const REMOVE_LINK_KEY = "removeLink";
export const LINK_VARIABLE_KEY = "linkToVariable";
export const REMOVE_VARIABLE_LINK_KEY = "removeVariableLink";

export const INSERT_MATH_KEY = "insertMath";

export const LINK_VARIABLE_ITEM_PREFIX = `${LINK_VARIABLE_KEY}:`;

export function isInlineTextStyleSuggestion(
  suggestion: Suggestion,
): suggestion is SingleSuggestion<"inlineTextStyle"> {
  return suggestion.type === "single" && suggestion.item.type === "inlineTextStyle";
}

export function isAddLinkSuggestion(
  suggestion: Suggestion,
): suggestion is SingleSuggestion<"inlineTextStyle"> {
  return isInlineTextStyleSuggestion(suggestion) && suggestion.item.key === ADD_LINK_KEY;
}

export function isRemoveLinkSuggestion(suggestion: Suggestion): boolean {
  return isInlineTextStyleSuggestion(suggestion) && suggestion.item.key === REMOVE_LINK_KEY;
}

export function isLinkToVariableSuggestion(
  suggestion: Suggestion,
): suggestion is SingleSuggestion<"variable"> {
  return (
    suggestion.type === "single" &&
    suggestion.item.type === "variable" &&
    !!suggestion.item.key?.startsWith(LINK_VARIABLE_ITEM_PREFIX)
  );
}

export function linkToVariableSymbol(suggestion: SingleSuggestion<"variable">): string {
  return suggestion.item.key?.slice(LINK_VARIABLE_ITEM_PREFIX.length) ?? "";
}

export function isRemoveVariableLinkSuggestion(suggestion: Suggestion): boolean {
  return (
    isInlineTextStyleSuggestion(suggestion) && suggestion.item.key === REMOVE_VARIABLE_LINK_KEY
  );
}

export function isInsertMathSuggestion(suggestion: Suggestion): boolean {
  return suggestion.type === "single" && suggestion.item.key === INSERT_MATH_KEY;
}
